
const weekDays = [
  { id: 1, name: 'Monday' },
  { id: 2, name: 'Tuesday' },
  { id: 3, name: 'Wednesday' },
  { id: 4, name: 'Thursday' },
  { id: 5, name: 'Friday' },
  { id: 6, name: 'Saturday' },
  { id: 7, name: 'Sunday' },
];
const months = [
  { id: 1, name: 'January' },
  { id: 2, name: 'February' },
  { id: 3, name: 'March' },
  { id: 4, name: 'April' },
  { id: 5, name: 'May' },
  { id: 6, name: 'June' },
  { id: 7, name: 'July' },
  { id: 8, name: 'August' },
  { id: 9, name: 'September' },
  { id: 10, name: 'October' },
  { id: 11, name: 'November' },
  { id: 12, name: 'December' },
];
const monthDays = Array.from({ length: 31 }, (_, i) => ({
  id: i + 1,
  name: (i + 1).toString(),
}));
const years = Array.from({ length: 31 }, (_, i) => ({
  id: 2000 + i,
  name: (2000 + i).toString(),
}));

export const bulkactions: any ={
    
      "Bulk Site Load Type Change": {
        title: "Bulk Site Load Type Change",
        fields: [
          { type: "select", class:"col-4", label: "From Site Load Type",formKey:'fromSiteLoadType' ,model: "selectedformsiteload", source: "siteloadlistfrom" },
          { type: "select", class:"col-4", label: "To Site Load Type",formKey:'toSiteLoadType' ,model: "selectedtositeload", source: "siteloadlistto" }
        ],
        submit: "SiteLoadTypeChange"
      },
    
      "Multiple Coupon Discard": {
        title: "Multiple Coupon Discard",
        fields: [
          { type: "text", class:"col-4", label: "Coupon Id*",formKey:'CouponId' ,model: "CouponId" },
          { type: "password", class:"col-4", label: "Password*",formKey:'Password' ,model: "Password" },
          { type: "text", class:"col-8", label: "Reason*",formKey:'Reason' ,model: "Reason" }
        ],
        submit: "MultipleCouponDiscard"
      },
    
      "Bulk Meter Make": {
        title: "Bulk Meter Make",
        fields: [
          { type: "select", class:"col-4", label: "Meter Make",formKey:'MeterMake' ,model: "selectedMeterMake", source: "MeterMakelist" }
        ],
        submit: "MeterMakeChange"
      },
    
      "Active Cut Off Status": {
        title: "Active Cut off Status",
        fields: [
          { type: "select", class:"col-4", label: "Tower",formKey:'TowerId' ,model: "selectedTowerlist", source: "towerlist" },
          { type: "selectYesNo", class:"col-4", label: "Status",formKey:'Status' ,model: "Y_Nselect" }
        ],
        submit: "ActiveCutOffStatus"
      },
    
      "Active Cut off Min Balance": {
        title: "Active Cut off Min Balance",
        fields: [
          { type: "select", class:"col-4", label: "Tower",formKey:'TowerId' ,model: "selectedTowerlist", source: "towerlist" },
          { type: "text", class:"col-4", label: "Amount*",formKey:'Amount' ,model: "amount" }
        ],
        submit: "ActiveCutOffMinBalance"
      },
    
      "Alter Site Login": {
        title: "Alter Site Login",
        fields: [
          { type: "select", class:"col-4", label: "Status",formKey:'Status' ,model: "Y_Nselect", source: [
            {id:'Y',name:'Enabled'},
            {id:'T',name:'Disabled'}
          ] 
        }
        ],
        submit: "AlterSiteLogin"
      },
    
      "Import Login Data": {
        title: "Import Login Data",
        fields: [
          { type: "text", class:"col-4", label: "Password*",formKey:'Password' ,model: "Password" }
        ],
        submit: "ImportLoginData"
      },
    
      "Low Balance Alert Amount": {
        title: "Low Balance Alert Amount",
        fields: [
          { type: "text", class:"col-4", label: "Amount*",formKey:'Amount' ,model: "amount" }
        ],
        submit: "LowBalanceAlertAmt"
      },
      "Flat Active Deactive Status": {
        title: "Low Balance Alert Amount",
        fields: [
          { type: "select", class:"col-4", label: "Status",formKey:'Status' ,model: "Status" ,source: [
            {id:'M',name:'Yes'},
            {id:'D',name:'No'}
          ]
         }
        ],
        submit: "FlatActiveDeactiveStatus"
      },
    "Notification SMS Status": {
        title: "Notification SMS Status",
        fields: [
          { type: "selectYesNo", class:"col-4", label: "Status",formKey:'Status' ,model: "Status",source: [
            {id:'Y',name:'Yes'},
            {id:'N',name:'No'}
           ]
          }
        ],
        submit: "NotificationSMSStatus"
      },
    "Bulk Restore Tower wise": {
        title: "Bulk Restore Tower Wise",
        fields: [
          { type: "select", class:"col-4", label: "Tower",formKey:'TowerId' ,model: "selectedTowerlist", source: "towerlist" },
          { type: "select", class:"col-4", label: "Action",formKey:'Action' ,model: "actionList", source: [
            {id:'POWERRESTORE',name:'POWERRESTORE'},
            {id:'POWERRESTOREGRID',name:'POWERRESTOREGRID'},
            {id:'POWERRESTOREDG',name:'POWERRESTOREDG'},
           ] 
          },
        ],
        submit: "BulkRestoreTowerWise"
      },
    "GST Charges Status": {
        title: "GST Charges Status",
        fields: [
          { type: "select", class:"col-3", label: "Charges",formKey:'Charges' ,model: "Charges", source: [
            {id:'CAM_st_charges',name:'CAM GST Charges'},
            {id:'CS_st_charges ',name:'CS GST Charges'},
            {id:'other_st_charges',name:'Other GST Charges'},
            {id:'dg_mmc_st_charges ',name:'DG MMC GST Charges'},
            {id:'dg_fixed_st_charges ',name:'DG Fixed GST Charges'}
           ] },
          { type: "select", class:"col-3", label: "Status",formKey:'Status' ,model: "Status", source: [
            {id:'Y',name:'Yes'},
            {id:'N ',name:'No'},
           ]
         },
        ],
        submit: "GSTChargesStatus"
      },
    "Threshold Unit": {
        title: "Threshold Unit",
        fields: [
          { type: "text", class:"col-4", label: "EM Grid Reading",formKey:'EMGridReading' ,model: "EMGridReading" },
          { type: "text", class:"col-4", label: "EM DG Reading",formKey:'EMDGReading' ,model: "EMDGReading" },
        ],
        submit: "ThresholdUnit"
      },
    "Bulk Happy Days": {
        title: "Bulk Restore Tower Wise",
        fields: [
          { type: "select", class:"col-4", label: "WeekDay",formKey:'WeekDay' ,model: "WeekDay", source: weekDays },
          { type: "select", class:"col-4", label: "Day",formKey:'Day' ,model: "Day", source: monthDays },
          { type: "select", class:"col-4", label: "Year",formKey:'Year' ,model: "Year", source: years },
          { type: "select", class:"col-4", label: "Month",formKey:'Month' ,model: "Month", source: months },
          { type: "text", class:"col-4", label: "Description",formKey:'Description' ,model: "Description" },
        ],
        submit: "BulkHappyDays"
      }
    
    
}
